/**
 * Dropdown
 * ======================================
 * - mobile only
 * - add class to parent on click
 * - and close others open on mobile
 */

const WIDGET = '.header-nav__item.has-submenu'
const ACTIVECLASS = 'is-open'
const IS_MOBILE = window.matchMedia("only screen and (max-width: 768px)").matches

export class HeaderNav {
  constructor() {
    this.elements = document.querySelectorAll(WIDGET)
  }

  init = () => {
   this.elements.forEach((el) => {
     const button = el.querySelector('a')

     if(button){
       button.addEventListener('click', this.clickHandler, false)
     }
  })
  }

  clickHandler = (e) => {
    const button = e.currentTarget
    const widget = button.closest(WIDGET)

    widget.classList.toggle(ACTIVECLASS)

    e.preventDefault()
  }
}

if(IS_MOBILE){
 const HeaderNavObject = new HeaderNav()
 HeaderNavObject.init()
}
